export enum CostCenterEnum {
  'Iot' = 'Iot',
  'Dealer' = 'Dealer',
  'Subtenant' = 'Subtenant',
  'Department' = 'Department',
  'User' = 'User'
}
